// extracted by mini-css-extract-plugin
export default {"tabs":"AlarmsTabs_tabs__VScuX","flexContainer":"AlarmsTabs_flexContainer__biWmJ","tab":"AlarmsTabs_tab__VgEqx","indicator":"AlarmsTabs_indicator__YejDB"};